import { Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import GeneralHeader from "../Pages/HeaderPage/HeaderPage";

const MainPageRoute = () => {

  const Auth=useSelector((state)=>state.Local.Auth)
  const navigate = useNavigate()


  useEffect(()=>{
    if(Auth!==true){
      navigate("/login")
    }
  },[Auth,navigate])

    return (
        <Fragment>
         <GeneralHeader/> 
         <Outlet/>
        </Fragment>
    );
}
 
export default MainPageRoute;